import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/hashInfo'

const getHashInfo = (payload, organization) => AxiosClient.post(
  resource, payload, { headers: { organization } }
)

export {
  getHashInfo
}
